import { authAxios } from "services";

export const fetchAll = (filters, page, searchParams = {}) => {
  const adjustedFilters = Object.keys(filters).map((filterIndex) => [
    `filters[${filterIndex}]`,
    filters[filterIndex],
  ]);
  const urlParams = new URLSearchParams(adjustedFilters);
  urlParams.append("page", page);

  Object.keys(searchParams).forEach((key) => {
    if (searchParams[key]) {
      urlParams.append(key, searchParams[key]);
    }
  });

  return authAxios().get(`/vehicleClasses?${urlParams.toString()}`);
};

export const fetchOptions = (filters) => {
  const adjustedFilters = Object.keys(filters).map((filterIndex) => [
    `filters[${filterIndex}]`,
    filters[filterIndex],
  ]);
  const urlParams = new URLSearchParams(adjustedFilters).toString();
  return authAxios().get(`/vehicleClasses/options?${urlParams}`);
};

export const create = (data) => authAxios().post(`/vehicleClasses`, data);

export const fetchById = (id) => authAxios().get(`/vehicleClasses/${id}`);

export const deleteById = (id) => authAxios().delete(`/vehicleClasses/${id}`);

export const updateById = (id, data) => authAxios().post(`/vehicleClasses/${id}?_method=PUT`, data);
